import { Button } from '@trackman/web-shared-components';
import { ServiceTypes } from 'constants/ServiceTypes';
import { SessionMode } from 'enums/SessionMode';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useInjection } from 'services/ioc/ioc.react';
import { NotificationStore } from 'stores/NotificationStore';
import { SessionStore } from 'stores/SessionStore';
import { GameSwitch } from './components/GameSwitch/GameSwitch';
import { ControlsWrapper, GameStateSwitch } from './GameControlStyles';

export const GameControl: React.FC = observer(() => {
  const sessionStore = useInjection<SessionStore>(ServiceTypes.SessionStore);
  const [displaySessionMode, setDisplaySessionMode] = useState<SessionMode>(sessionStore.currentSessionMode.sessionMode);
  const notificationStore = useInjection<NotificationStore>(ServiceTypes.NotificationStore);

  useEffect(() => {
    setDisplaySessionMode(sessionStore.currentSessionMode.sessionMode);
  }, [sessionStore.currentSessionMode.sessionMode]);

  const updateSessionMode = async (mode: SessionMode) => {
    const isSuccess = await sessionStore.setCurrentSessionMode({
      ...sessionStore.currentSessionMode,
      sessionMode: mode,
    });
    if (!isSuccess) {
      notificationStore.addNotification({
        id: 'session-mode-error',
        message: 'Error changing session mode',
        variant: 'error',
        removable: true,
        onClose: () => {
          notificationStore.removeNotification('session-mode-error');
        },
      });
    }
  };

  const handleOnChange = async (checked: boolean) => {
    if (checked) {
      notificationStore.removeNotification('warmup-started');

      await updateSessionMode(SessionMode.PlayingStarted);
      notificationStore.addNotification({
        id: 'game-started',
        message: 'You have started the game, all plays will now be tracked and saved.',
        variant: 'success',
        removable: true,
        onClose: () => {
          notificationStore.removeNotification('game-started');
        },
      });
    } else if (!checked) {
      notificationStore.removeNotification('game-started');
      await updateSessionMode(SessionMode.WarmupStarted);
      notificationStore.addNotification({
        id: 'warmup-started',
        message: 'You are in warmup mode, pitches will not be tracked.',
        variant: 'warning',
        removable: true,
        onClose: () => {
          notificationStore.removeNotification('warmup-started');
        },
      });
    }
  };

  const handleOnClickGameStart = async () => {
    updateSessionMode(SessionMode.WarmupStarted);
  };

  const handleClickGameEnd = () => {
    sessionStore.setIsEndGameModalVisible(true);
  };

  return (
    <div>
      {displaySessionMode === SessionMode.SessionStarted ? (
        <Button label='Start game' width={101} onClick={handleOnClickGameStart} intent='secondary' data-test='start-game-button' />
      ) : displaySessionMode === SessionMode.PlayingStarted || displaySessionMode === SessionMode.WarmupStarted ? (
        <ControlsWrapper>
          <Button
            label='End game'
            width={89}
            onClick={handleClickGameEnd}
            disabled={displaySessionMode === SessionMode.PlayingStarted}
            intent='secondary'
            data-test='end-game-button'
          />
          <GameStateSwitch>
            <GameSwitch
              isPlaying={displaySessionMode === SessionMode.PlayingStarted}
              onChangeCallback={(checked: boolean) => handleOnChange(checked)}
            />
            {/* <EndButton
            onClickCallback={handleClickGameEnd}
            isDisabled={displaySessionMode === SessionMode.PlayingStarted}
            data-test='end-game-button'
          /> */}
          </GameStateSwitch>
        </ControlsWrapper>
      ) : null}
    </div>
  );
});
